import { c as _c } from "react/compiler-runtime";
import { createRoot } from 'react-dom/client';
import './sentry/sentry-instrument';
// sentry must be imported first
import ErrorBoundary from '@/components/modules/ErrorBoundary';
import router from '@/routes';
import * as Sentry from '@sentry/react';
import { LoaderWithContainer } from '@winelidays/wld-tsx-2/elements';
import { StrictMode, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ENV, ESTABLISHMENT_NAME, HOME_PATH, INITIAL_APP_URL, LOCALE, WITH_REVIEWS } from './constants/config';
import initializeGTM from './utils/gtm/initializeGTM';
Sentry.setTag('app', 'react');
Sentry.setTag('react.env', ENV);
Sentry.setTag('initial_url', INITIAL_APP_URL);
Sentry.setTag('locale', LOCALE);
Sentry.setTag('home_path', HOME_PATH);
Sentry.setTag('establishment_name', ESTABLISHMENT_NAME);
Sentry.setTag('with_reviews', WITH_REVIEWS);
const App = () => {
    const $ = _c(4);
    const [isGTMInitialized, setIsGTMInitialized] = useState(false);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = () => {
            initializeGTM(() => {
                setIsGTMInitialized(true);
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    }
    else {
        t0 = $[0];
        t1 = $[1];
    }
    useEffect(t0, t1);
    let t2;
    if ($[2] !== isGTMInitialized) {
        t2 = <ErrorBoundary>
      {isGTMInitialized ?
                <RouterProvider router={router} fallbackElement={<LoaderWithContainer className="h-72"/>}/> :
                <LoaderWithContainer className="h-72"/>}
    </ErrorBoundary>;
        $[2] = isGTMInitialized;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    return t2;
};
const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(<StrictMode>
      <App />
    </StrictMode>);
}
